.xconnect-list.dl-horizontal dd{margin-left:250px}.xconnect-list.dl-horizontal dt{width:240px}
/*# sourceMappingURL=appscripts-user-index.component-N5RK26A6.css.map */
